<template>

  <div class="dps-group">

  <ul>
    <li class="dps-group-header">

      <div>
        <label v-bind:for="this.group.id">
          <strong>{{ this.group.name }}</strong>
        </label>
      </div>

    </li>
    <medium-item
      v-for="medium in media"
      :medium="medium"
      :key="medium.name"
      :onSelected="selectedMedium"
    >
    </medium-item>
  </ul>

  </div>

</template>

<script>

import MediumItem from './MediumItem.vue'

export default {

  name: 'group-item',
  components: { MediumItem },

  props: {
    group: {
      type: Object,
      required: true
    }
  },

  data () {
    return {}
  },

  computed: {

    media: function() {
      return this.$store.getters.mediaByGroup(this.group.name)
    }

  },

  methods: {

    selectedMedium: function(selectedMedium) {

      if(selectedMedium.aggregated) {

        this.media.forEach(medium => {
          if (!medium.aggregated) {
            medium.disabled = selectedMedium.selected
            medium.selected = false
          }
        })

      }

    },

  }

}

</script>

<style>

  .dps-group {
    width: 50%;
  }

  .dps-group-header {
    border-bottom: 2px solid #0b5b8f;
    background: #fbfafa;
    padding: 10px;
    margin: 0;
    margin-bottom: 10px;
  }

</style>



// WEBPACK FOOTER //
// src/components/GroupItem.vue